import { useEffect } from "react";

/**
 * Force the document into light mode for the lifetime of the component.
 * Used by marketing/admin layouts that should never appear in dark mode,
 * even when the user has toggled dark mode inside the app.
 */
export function useForceLightTheme() {
  useEffect(() => {
    const root = document.documentElement;
    const wasDark = root.classList.contains("dark");
    if (wasDark) root.classList.remove("dark");
    return () => {
      if (wasDark) root.classList.add("dark");
    };
  }, []);
}
